var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProviderBalances(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5025_25409)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5025_25409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1154 3.24667V1.91667C12.1154 1.275 11.55 0.75 10.859 0.75H2.06415C1.36684 0.75 0.807739 1.275 0.807739 1.91667V10.0833C0.807739 10.725 1.36684 11.25 2.06415 11.25H10.859C11.55 11.25 12.1154 10.725 12.1154 10.0833V8.75333C12.4861 8.54917 12.7436 8.18167 12.7436 7.75V4.25C12.7436 3.81833 12.4861 3.45083 12.1154 3.24667ZM11.4872 4.25V7.75H7.08979V4.25H11.4872ZM2.06415 10.0833V1.91667H10.859V3.08333H7.08979C6.39877 3.08333 5.83338 3.60833 5.83338 4.25V7.75C5.83338 8.39167 6.39877 8.91667 7.08979 8.91667H10.859V10.0833H2.06415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97405 6.875C9.49447 6.875 9.91635 6.48325 9.91635 6C9.91635 5.51675 9.49447 5.125 8.97405 5.125C8.45362 5.125 8.03174 5.51675 8.03174 6C8.03174 6.48325 8.45362 6.875 8.97405 6.875Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5025_25409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11.4706,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5025_25409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0769,
    height: 14,
    fill: "white",
    transform: "translate(-1.0769 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderBalances);
export default __webpack_public_path__ + "static/media/provider-balances.deb3cf9b71620e73a02318e433f5d7c6.svg";
export { ForwardRef as ReactComponent };